import React, { useEffect, useState } from 'react';

function GroupHeader({ headerImage, groupName }) {
    const [imgUrl, setImgUrl] = useState(null);

    useEffect(() => {
        let isMounted = true;
        const imageToLoad = headerImage || "background1";
        import(`../../media/backgrounds/${imageToLoad}.png`).then(module => {
            if (isMounted) setImgUrl(module.default);
        });
        return () => { isMounted = false; };
    }, [headerImage]);

    return (
        <>
            <style>
                {`
                    #groupNameHeader {
                        position: relative;
                        height: 8rem;
                    }

                    #groupNameHeader:before {
                    content: ' ';
                    display: block;
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 100%;
                    height: 100%;
                    opacity: 0.4;
                    background-image:  ${imgUrl ? `url(${imgUrl})` : 'none'};
                    background-repeat: no-repeat;
                    background-position: 50% 0;
                    background-size: cover;
                    }

                    .group-header-content {
                    position: relative;
                    }
                `}
            </style>

            <section id="groupNameHeader" className="hero is-extra-small  mb-2 mt-0">
                <div className="hero-body group-header-content">
                    <div className="mr-auto ml-auto has-text-weight-semibold has-text-grey-darker is-size-4 title">
                        <figure className="image is-48x48 ml-auto mr-auto is-size-7">
                        </figure>
                        {groupName || <span>&nbsp;</span>}
                    </div>
                </div>
            </section>
        </>
    );
}

export default GroupHeader;